export default __webpack_public_path__ + "static/media/logo.16a19b39.png";